// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"10":"54c5dc8a","16":"364e0a59","454":"14e50354","551":"946ca0a5"}[chunkId] + ".css";
};